<template>
    <div class="warning">
        <van-overlay :show="show" @click="hidewarning" :z-index="999">
            <div class="warning-wrapper flex-column align-center" @click.stop>
                <img class="warning-header-img" :src="pageImg" alt="" />
                <p class="warning-result"></p>
                <p class="warning-description">您尚未登录，登录后享受更多停车服务</p>
                <van-button class="warning-confirm-btn" @click="comfirm" block>去登录</van-button>
            </div>
            <div class="close" @click="hidewarning">
                <img src="@/assets/images/close.png" alt="" />
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { isMiniprogram } from "@/libs/env";

export default {
    name: "WarningLogin",
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        content: String,
    },
    data() {
        return {
            pageImg: require("@/assets/images/warining-success.png"),
        };
    },
    methods: {
        handleShowwarning() {
            this.$emit("update:show");
        },
        hidewarning() {
            this.$emit("update:show", false);
        },
        handleConfirm() {
            this.$emit("handleConfirm");
        },
        comfirm() {
            if (isMiniprogram()) {
                wx.miniProgram.redirectTo({
                    url: `/pages/login/login?type=loginout`,
                });
            }
            else {
                this.$router.push("/wxAuth?page=login");
            }

        },
    },
};
</script>

<style lang="less" scoped>
.warning {
    .warning-wrapper {
        width: 599px;
        height: 584px;
        background: #ffffff;
        border-radius: 20px;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;
        margin: auto;
        .warning-header-img {
            width: 100%;
            height: 220px;
        }
        .warning-result {
            font-size: 36px;
            color: #212121;
            margin: 48px 0;
        }
        .warning-description {
            font-size: 30px;
            color: #616161;
            line-height: 40px;
            padding: 0 38px;
        }
        .warning-confirm-btn {
            width: 512px;
            height: 70px;
            color: #fff;
            background-image: linear-gradient(90deg, #009af3 0%, #00c6ea 100%);
            margin-top: 50px;
            font-size: 32px;
            padding: 0 38px;
        }
    }
    .close {
        position: absolute;
        bottom: calc(50vh - 292px - 56px - 36px);
        left: 0;
        right: 0;
        margin: auto;
        width: 72px;
        height: 72px;
        img {
            width: 100%;
            height: 100%;
        }
    }
}
</style>
